export enum hoshinInfoForPrint {
 bpgInitiative = 'BPG Initiative',
 status = 'Status',
 businessDrivers = 'Business Drivers',
 proposedBudget = 'Proposed Budget',
 frequency = 'Frequency',
 lead1Name = 'Lead 1',
 lead2Name = 'Lead 2',
 actionPlan = 'Action Plan', 
 kpi= 'KPI',
 midYearResults = 'Mid Year Results',
 yearEndResults = 'Year End Results',
 challenges = 'Challenges/Counter Measure',
 evaluation= 'Evaluation ',
 additionalFundingSource =  'Addition Funding Source',
 superAdminApprovedBudget ='Approval Amount',
 superAdminApprovalComment = 'Approval/Reject Comment'
}